

import { classesRuntime, statesRuntime } from "@stylable/runtime";



const _namespace_ = "/* INJECT */ {__namespace__:true}";
const _style_ = (...args) => classesRuntime(_namespace_, ...args);

export const cssStates = (stateMapping) => statesRuntime(_namespace_, stateMapping);
export const style = _style_;
export const st = _style_;

export const namespace = _namespace_;
export const classes = "/* INJECT */ {__classes__:true}";
export const keyframes = "/* INJECT */ {__keyframes__:true}"; 
export const layers = "/* INJECT */ {__layers__:true}";
export const containers = "/* INJECT */ {__containers__:true}";
export const stVars = "/* INJECT */ {__stVars__:true}"; 
export const vars = "/* INJECT */ {__vars__:true}"; 



if(import.meta.webpackHot /* HMR */) { import.meta.webpackHot.accept();}
